import { IWallet } from "@/types/Wallet";
import { create } from "zustand";

export interface CategoryNode {
  _id?: string;
  name: string;
  slug: string;
  categories: CategoryNode[];
}
interface StoreInfoType {
  name?: string;
  receivingWalletId?: string;
  _id?: string;
  socials?: { name: string; url: string }[];
  description?: string;
  pagination: boolean;
  storeId?: string;
  language?: string;
  customAdditionalSections?: any;
  logo?: string;
  currency?:string
  source?: string;
  followersCount:number
  displaySettings?: {
    sortBy?: string;
    showRating?: boolean;
    showStockInfo?: boolean;
  };
  priceSettings?: {
    decimalPrecision?: number;
  };
}

interface DashboardStore {
  wallet: IWallet[];
  orders: any;
  stats: any;
  notifications: any[];
  StoreInfo: StoreInfoType | null;
  categories: CategoryNode[];
  setWallet: (wallet: any[]) => void;
  setOrders: (orders: any) => void;
  setStats: (stats: any) => void;
  setNotifications: (n: any[]) => void;
  setStoreInfo: (n: StoreInfoType | null) => void;
  setCategories: (categories: CategoryNode[]) => void;
}

export const useDashboardStore = create<DashboardStore>((set) => ({
  wallet: [],
  sellerProducts: [],
  orders: null,
  stats: null,
  notifications: [],
  StoreInfo: null,
  categories: [],

  setWallet: (wallet) => set({ wallet }),
  setOrders: (orders) => set({ orders }),
  setStats: (stats) => set({ stats }),
  setNotifications: (n) => set({ notifications: n }),
  setStoreInfo: (s) => set({ StoreInfo: s }),
  setCategories: (categories) => set({ categories }),
}));
